import inView from './viewport';

export default function faq () {
    const faqItems = Array.from(document.querySelectorAll('.faq-item')); // Convert NodeList to Array
    const faqFilters = Array.from(document.querySelectorAll('.faq-filter a'));

    // Function to close all FAQ items
    const closeAllFaqItems = () => {
        faqItems.forEach(item => {
            item.classList.remove('active');
            const answer = item.querySelector('.faq-answer');

            if (answer) {
                $(answer).slideUp(300);
            } // Assuming jQuery is available
        });
    };

    // Function to toggle FAQ item
    const toggleFaqItem = (item, answer) => {
        const isActive = item.classList.contains('active');

        closeAllFaqItems();
        if (!isActive) {
            item.classList.add('active');
            $(answer).slideDown(300); // Assuming jQuery is available
        }
    };

    // Initialize FAQ items
    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        if (question && answer) {
            question.addEventListener('click', () => toggleFaqItem(item, answer));
        }
    });

    // Function to filter FAQ items
    const filterFaqItems = (ID) => {
        faqItems.forEach(el => {
            const matches = ID === 0 || parseInt(el.getAttribute('data-term_id'), 10) === ID;

            // Remove 'active' class and collapse answers for hidden items
            if (!matches) {
                el.classList.remove('active');
                const answer = el.querySelector('.faq-answer');

                if (answer) {
                    $(answer).slideUp(300);
                } // Collapse hidden answers
            }

            // Toggle display based on filter match
            el.style.display = matches ? 'block' : 'none';
        });
    };

    // Initialize FAQ filters
    faqFilters.forEach(filter => {
        const ID = parseInt(filter.getAttribute('data-term_id'), 10);

        filter.addEventListener('click', () => {
            faqFilters.forEach(f => f.classList.remove('active'));
            filter.classList.add('active');
            filterFaqItems(ID);
            inView();
        });
    });
}
